import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Static imports — bundled into APK, no network requests for translations
import en_common from '../../public/locales/en/common.json';
import en_auth from '../../public/locales/en/auth.json';
import en_parent from '../../public/locales/en/parent.json';
import en_driver from '../../public/locales/en/driver.json';
import en_admin from '../../public/locales/en/admin.json';

import hi_common from '../../public/locales/hi/common.json';
import hi_auth from '../../public/locales/hi/auth.json';
import hi_parent from '../../public/locales/hi/parent.json';
import hi_driver from '../../public/locales/hi/driver.json';
import hi_admin from '../../public/locales/hi/admin.json';

import od_common from '../../public/locales/od/common.json';
import od_auth from '../../public/locales/od/auth.json';
import od_parent from '../../public/locales/od/parent.json';
import od_driver from '../../public/locales/od/driver.json';
import od_admin from '../../public/locales/od/admin.json';

import bn_common from '../../public/locales/bn/common.json';
import bn_auth from '../../public/locales/bn/auth.json';
import bn_parent from '../../public/locales/bn/parent.json';
import bn_driver from '../../public/locales/bn/driver.json';
import bn_admin from '../../public/locales/bn/admin.json';

import ta_common from '../../public/locales/ta/common.json';
import ta_auth from '../../public/locales/ta/auth.json';
import ta_parent from '../../public/locales/ta/parent.json';
import ta_driver from '../../public/locales/ta/driver.json';
import ta_admin from '../../public/locales/ta/admin.json';

import te_common from '../../public/locales/te/common.json';
import te_auth from '../../public/locales/te/auth.json';
import te_parent from '../../public/locales/te/parent.json';
import te_driver from '../../public/locales/te/driver.json';
import te_admin from '../../public/locales/te/admin.json';

import kn_common from '../../public/locales/kn/common.json';
import kn_auth from '../../public/locales/kn/auth.json';
import kn_parent from '../../public/locales/kn/parent.json';
import kn_driver from '../../public/locales/kn/driver.json';
import kn_admin from '../../public/locales/kn/admin.json';

const resources = {
  en: { common: en_common, auth: en_auth, parent: en_parent, driver: en_driver, admin: en_admin },
  hi: { common: hi_common, auth: hi_auth, parent: hi_parent, driver: hi_driver, admin: hi_admin },
  od: { common: od_common, auth: od_auth, parent: od_parent, driver: od_driver, admin: od_admin },
  bn: { common: bn_common, auth: bn_auth, parent: bn_parent, driver: bn_driver, admin: bn_admin },
  ta: { common: ta_common, auth: ta_auth, parent: ta_parent, driver: ta_driver, admin: ta_admin },
  te: { common: te_common, auth: te_auth, parent: te_parent, driver: te_driver, admin: te_admin },
  kn: { common: kn_common, auth: kn_auth, parent: kn_parent, driver: kn_driver, admin: kn_admin },
};

const savedLang = localStorage.getItem('i18n_lang') || 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: savedLang,
    fallbackLng: 'en',
    ns: ['common', 'auth', 'parent', 'driver', 'admin'],
    defaultNS: 'common',
    resources,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false, // No suspense needed — translations are bundled
    },
  });

export default i18n;
